import { useTranslation } from 'react-i18next'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useListWorkflows } from '@omnea-app/fe-reporting/useListWorkflows'
import { WorkflowStateEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const useUnpublishedWorkflowsBannerInfo = () => {
  const { t } = useTranslation('common')
  const { user } = useAuthenticatedUser()
  const { data, isLoading } = useListWorkflows({ skip: !user.isAdmin, state: [WorkflowStateEnum.UNDER_MAINTENANCE] })

  const unpublishedWorkflowCount = isLoading ? 0 : (data?.workflows.length ?? 0)
  const shouldShowBanner = user.isAdmin && unpublishedWorkflowCount > 0

  const bannerText =
    unpublishedWorkflowCount > 0 ? t('under-maintenance-workflows-banner', { count: unpublishedWorkflowCount }) : ''

  return { shouldShowBanner, bannerText, isLoading }
}
